import { RefreshCw, X } from 'lucide-react';

/**
 * Fixed top banner when a newer frontend build is deployed.
 */
export default function AppUpdateBanner({ visible, onRefresh, onDismiss }) {
  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[60] border-b border-primary-800 bg-primary-700 text-white shadow-md"
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-3 gap-y-2 px-4 py-2.5 text-sm">
        <RefreshCw className="h-4 w-4 shrink-0 opacity-90" aria-hidden />
        <span>A new version of Zan Gateway is available.</span>
        <button
          type="button"
          onClick={onRefresh}
          className="font-semibold underline underline-offset-2 hover:text-primary-100"
        >
          Refresh to update
        </button>
        <button
          type="button"
          onClick={onDismiss}
          className="ml-1 inline-flex items-center rounded p-1 text-primary-100 hover:bg-primary-600 hover:text-white"
          title="Dismiss until next visit"
          aria-label="Dismiss update notification"
        >
          <X className="h-4 w-4" aria-hidden />
        </button>
      </div>
    </div>
  );
}
